<template>
  <b-card class="sm-leaderboard" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <template #header>
      <h6 class="mb-0">Top Sales Managers</h6>
    </template>
    <b-card-body>
      <b-table :items="salesManagers" :fields="fields" per-page="5" small striped responsive></b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTable } from 'bootstrap-vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';

export default {
  name: 'SmLeaderboard',
  components: {
    BCard,
    BCardBody,
    BTable,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },

  data() {

    return {

      fields: [
        { key: 'manager_name', label: 'Sales Manager' },
        { key: 'total_closures', label: 'Total Closures' },
        { key: 'total_revenue', label: 'Total Revenue' },
      ],
      salesManagers: [],

    };

  },

  watch: {
    dashboardData: {
      deep: true,
      handler(val) {
        if (val && val.sales_manager_leaderboard != null && hasRight(this.user, 'dashboard', 'view')) {
          this.salesManagers = Array.isArray(val.sales_manager_leaderboard) ? [...val.sales_manager_leaderboard] : [];
        }
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.sales_manager_leaderboard != null) this.salesManagers = Array.isArray(this.dashboardData.sales_manager_leaderboard) ? [...this.dashboardData.sales_manager_leaderboard] : [];
          return;
        }
        if (this.dashboardData && this.dashboardData.sales_manager_leaderboard != null) { this.salesManagers = Array.isArray(this.dashboardData.sales_manager_leaderboard) ? [...this.dashboardData.sales_manager_leaderboard] : []; return; }
        this.fetchSalesManagerLeaderboardData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.sales_manager_leaderboard != null) this.salesManagers = Array.isArray(this.dashboardData.sales_manager_leaderboard) ? [...this.dashboardData.sales_manager_leaderboard] : [];
            return;
          }
          this.fetchSalesManagerLeaderboardData();
        } else {
          this.salesManagers = [];
        }
      },
    },
  },

  methods: {

    hasRight, // Make the helper available in the template

    async fetchSalesManagerLeaderboardData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.sales_manager_leaderboard != null)) {
        if (this.dashboardData && this.dashboardData.sales_manager_leaderboard != null) this.salesManagers = Array.isArray(this.dashboardData.sales_manager_leaderboard) ? [...this.dashboardData.sales_manager_leaderboard] : [];
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/sales-manager-leaderboard', this.filters);
        const raw = response.data && response.data.data;
        this.salesManagers = Array.isArray(raw) ? [...raw] : [];

      } catch (error) {

        console.error('Error fetching sales manager leaderboard data:', error);

        // Handle error

      }

    },

  },

};

</script>



<style scoped>

.sm-leaderboard {

  margin-top: 20px;

}

</style>